/**
 * Check if cookies are enabled and displays warning message if they are disabled.
 */
(() => {
  if (!navigator.cookieEnabled) {
    document.querySelector('#no_cookies_warning').classList.remove('is-hidden');
  }
})();
